export default __webpack_public_path__ + "static/media/armepCover.b03bdad3.jpg";